import React, { ReactNode, useEffect, useState, useRef } from 'react'
import { Link } from 'gatsby'
import styles from './integration-cards.module.css'
import dataMap from './data'
import Image from '../../../templates/Image'

interface IntegrationCardsProps {
  dataKey: string
  children: ReactNode | ReactNode[]
}

export const IntegrationCards: React.FC<IntegrationCardsProps> = ({
  children,
  dataKey,
}) => {
  if (!dataMap.hasOwnProperty(dataKey)) {
    console.error('Invalid data key given to card component', dataKey)
    return null
  }

  const { heading, description, data } = dataMap[dataKey]
  return (
    <div className={styles.section}>
      <h2>{heading}</h2>
      <p>{description}</p>
      <div className={styles.cards}>
        {data.map(
          (
            { image, tag, heading, description, link }: any,
            key: React.Key | null | undefined,
          ) => (
            <div className={'whiteBox ' + styles.card} key={key}>
              <div className={styles.header}>
                <div className={styles.imageWrapper}>
                  <img src={image} alt="" />
                </div>
                <div
                  className={`${styles.tag} ${styles[tag.bgColor]}`}
                  style={{ color: tag.text === 'API' ? '#fff' : '' }}
                >
                  {tag.text}
                </div>
              </div>
              <div>
                <a href={link} target="_blank" rel="noreferrer">
                  {heading}
                </a>
              </div>
              <p>{description}</p>
            </div>
          ),
        )}
      </div>
    </div>
  )
}
